import { Component, Input } from '@angular/core';
import { IUserIdentificationRequest } from '../../../../../classes/unlock-account-authentication';
import { AppSettings } from '../../../../../app.settings';

@Component({
	selector: 'basic-info',
	template: require('./basic-info.component.html'),
})
export class BasicInfoComponent {
	@Input() isBlocked: boolean;
	public deletePassFields = AppSettings.deletePassFields;
	constructor() {}

	@Input() identifyRequest: IUserIdentificationRequest;
	@Input() public isLoginBigModalEnabled: boolean = false;
}
